export enum ApplicationType {
  CbMpads5_5 = 'CB MPADS 5.5',
  CbMpads6_1_0 = 'CB MPADS 6.1.0',
  CbMpeContact5_5 = 'CB MPE CONTACT 5.5',
}
